import React, { Component } from 'react'
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Grid, MenuItem } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from '../../http-config'
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import { STATEDASHBOARDUSER } from '../../../src/config/constant'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as actionCreators from '../../store/actions/index'
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
// import Alert from '@material-ui/lab/Alert';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withTranslation } from 'react-i18next';
class UserForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username:!!this.props&&this.props.userName ? this.props.userName : "",
            email:!!this.props&& this.props.email ? this.props.email : "",
            role: !!this.props&&this.props.roleId ? this.props.roleId : "",
            ulb:!!this.props&& this.props.ULBId ? this.props.ULBId : "",
            roleOptions: [],
            ulbOptions: [],
            usernameErr: "",
            emailErr: "",
            roleErr: "",
            ulbErr: "",
            roleName: undefined,
            dashboard:  false,
            iotdashboard:  false,
            statedashboard: false,
            ulbManagement: false,
            roleManagement: false,
            userManagement:  false,
            clusterManagement:  false,
            propertyManagement:  false,
            loadsRecords: false,
            ScheduleProperties: false,
            TreatmentFacilities:  false,
            OperatorManagement:  false,
            WardManagement: false,
            password:"",
            passwordErr:"",
            isPasswordShown:false,
            isBlank: true

        }
    }
    componentDidMount() {
        axios({
            method: 'get',
            url: `/role/?admin=${true}`,
            headers: { 'Authorization': `Bearer ${this.props.token}` }
        })
            .then((response) => {
                this.setState({ roleOptions: response.data.data })
            })
        axios({
            method: 'get',
            url: `ulb`,
            headers: { 'Authorization': `Bearer ${this.props.token}` }
        })
            .then((response) => {
                this.setState({ ulbOptions: response.data.data.ulbs })
            })
    }
    handleSubmit = (e) => {
        const {t, i18n} = this.props
        e.preventDefault()
        // console.log(this.props,"props")
        const err = this.checkValidity()
        if (!err) {
            const props = this.props
            const formdata = {
                token: this.props.token,
                userName: this.state.username,
                email: this.state.email,
                roleId: this.state.role.roleId,
                ulbId: !(this.state.roleName == STATEDASHBOARDUSER) ? this.state.ulb : null,
                password :this.state.password,
                isModuleAccess: {
                    "IsDashboardAccess": this.state.dashboard,
                    "IsPropertyManagementAccess": this.state.propertyManagement,
                    "IsSchedulePropertyAccess": this.state.ScheduleProperties,
                    "IsTreatmentFacilityAccess": this.state.TreatmentFacilities,
                    "IsOperatorManagementAccess": this.state.OperatorManagement,
                    "IsLoadRecordAccess": this.state.loadsRecords,
                    "IsWardManagementAccess": this.state.WardManagement,
                    "IsIOTDashboardAccess": this.state.iotdashboard,
                    "IsStateDashboardAccess": this.state.statedashboard,
                    "IsULBManagementAccess": this.state.ulbManagement,
                    "IsRoleManagementAccess": this.state.roleManagement,
                    "IsUserManagementAccess": this.state.userManagement,
                    "IsClusterULBManagementAccess": this.state.clusterManagement
                }
            }
            this.props.onAddUser(formdata, props, t)
            this.handleClosep();
        }
    }
    handleChange = (e) => {
        if (e.target.name == 'role') {
            this.setState({
                "roleName": e.target.value.name,
                [e.target.name]: e.target.value
            }, () => {
                this.checkValidity()
            })
        } else {
            this.setState({ [e.target.name]: e.target.value }, () => {
                this.checkValidity()
            })
        }
    }
    toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
    checkValidity = () => {
        const {t, i18n } = this.props
        let isError = false
        if (!this.state.username) {
            isError = true
            this.setState({ usernameErr: `${t("required")}` })
        }
        else if ((this.state.username.length > 0 && this.state.username.length < 3) || (this.state.username.length > 25)) {
            isError = true
            this.setState({ usernameErr: `${t("ulbAdminErr")}` })
        }
        else {
            this.setState({ usernameErr: '' })
        }
        if (this.state.email) {
            var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if (!this.state.email.match(mailformat)) {
                isError = true
                this.setState({ emailErr: `${t("ulbEmailErr")}` })
            }
            else {
                this.setState({ emailErr: '' })
            }
        }
        else if (!this.state.email) {
            this.setState({ emailErr: `${t("required")}` })
        }
        if (!this.state.role) {
            isError = true
            this.setState({ roleErr: `${t("required")}` })
        }
        else {
            this.setState({ roleErr: '' })
        }
        if (!(this.state.roleName == STATEDASHBOARDUSER) && !this.state.ulb) {
            isError = true
            this.setState({ ulbErr: `${t("required")}` })
        }
        else {
            this.setState({ ulbErr: '' })
        }

        if(this.state.username && !this.state.password){
            isError = true
            this.setState({
                passwordErr: `${t("required")}`,
               
            })
        }else{
            this.setState({
                passwordErr:''
            })  
        }
       

        if(this.state.username && this.state.password){
            if(!this.state.password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
                isError = true
                this.setState({
                    passwordErr: `${t('ulbPassErr')}`
                })   
            }else{
            
                this.setState({
                    passwordErr:''
                })   
            }
        }
        this.setState({isBlank: isError})
        return isError
    }
    handleChecked = (e) => {
        this.setState({ [e.target.name]: e.target.checked })
    }

    handleClosep =()=>{
        this.props.handleclose(false)
        this.setState({
            username: "",
            email: "",
            role: "",
            ulb:  "",
            // roleOptions: [],
            // ulbOptions: [],
            usernameErr: "",
            emailErr: "",
            roleErr: "",
            ulbErr: "",
            roleName: undefined,
            passwordErr:'',
            password:''
     })
    }
    render() {
        const {t, i18n} = this.props
        return (
            <div>
        <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        // open={true}
        open={this.props.open}
        >
       {/* <Dialog open={this.props.open} onClose={this.handleClosep} maxWidth='md'> */}
         <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{t("addUser")} </span></DialogTitle>
                <DialogContent>
                <div className="create_ulb_content_outer">
                <div className="create_ulb_content create_ulb_contentPop">

                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="username">{t("userName")}</label>
                                    <TextField id="username"
                                        variant="outlined"
                                        placeholder= {`${t("enterUser")}`}
                                        name="username"
                                        value={this.state.username}
                                        onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.usernameErr}</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="email">{t("email")}</label>
                                    <TextField id="email"
                                        variant="outlined"
                                        placeholder= {`${t("enterEmail")}`}
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.emailErr}</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                     <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("userPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder= {`${t("enterPass")}`} 
                                      name="password" 
                                      value={this.state.password}
                                      onChange={this.handleChange}
                                      type={this.state.isPasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isPasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.toggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.toggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.passwordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                  </FormControl>
                  </form>
                    </Grid>


                            <Grid item xs={6} >

                                <FormControl>
                                    <label className="required" htmlFor="role">{t("role")}</label>
                                    {
                                        this.props.unAssignable ?
                                            <TextField variant="outlined"
                                                value={this.props.role}
                                                disabled={true}
                                                style={{ width: '99%' }}
                                            />
                                            :
                                            <Select value={this.state.role}
                                                onChange={this.handleChange}
                                                name="role">
                                                {this.state.roleOptions.map((role) => (
                                                    <MenuItem value={role}>{role.name}</MenuItem>
                                                ))}
                                            </Select>
                                    }

                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.roleErr}</div>
                                </FormControl>
                            </Grid>
                            {!(this.state.roleName == STATEDASHBOARDUSER) &&
                                <Grid item xs={6}>
                                    <FormControl>
                                        <label className="required" htmlFor="ulb">{t("ulb")}</label>
                                        <Select value={this.state.ulb}
                                            onChange={this.handleChange}
                                            name="ulb"
                                            style={{ width: '99%' }}>
                                            {this.state.ulbOptions.map((ulb) => (
                                                <MenuItem value={ulb.ulbId}>{ulb.name}</MenuItem>
                                            ))}
                                        </Select>
                                        <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.ulbErr}</div>
                                    </FormControl>
                                </Grid>
                            }

                        
                        </Grid>
 
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <div className="create_ulb_buttons" style={{marginBottom:'10px'}}>
                                    <Button className="login_submit" variant="outlined" color="primary" onClick={this.handleClosep}>{t("cancel")}</Button>
                                    <Button className="login_submit" variant="contained" color="primary" disabled={this.state.isBlank} onClick={this.handleSubmit}>{t("save")}</Button>
                                </div>
                            </Grid>
                        </Grid>

                    </div>
                </div>
                </DialogContent>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token
})

const mapDispatchToProps = (dispatch) => {
    return({
        onAddUser : (payload,props, t) => dispatch(actionCreators.addUser(payload,props, t))
    })
}


export default connect(mapStateToProps, mapDispatchToProps) (withTranslation()(UserForm))